import React, { useState } from 'react';
import { Button, Dialog, Grid, Typography } from '@mui/material';
import { ActivityInterface, useActivitiesContext } from 'pages/Activities/activities.context';
import { useMutation } from '@apollo/client';
import { useSnackbarContext } from 'context/snackbar.context';
import { COMPLETE_ACTIVITY } from 'graphql/activities/mutations/completeActivity.gql';
import styled from 'styled-components';
import { ErrorTextWrapper } from 'pages/Campaigns/UpdateCampaign';
import { hasPermissions } from 'config/ability';
import { useAuthContext } from 'context/auth.context';

const TextWrapper = styled.div`
  margin: 2rem;
`;

const CompleteActivity = ({ activity }: { activity: ActivityInterface }) => {
  const [showCompleteActivityModal, setShowCompleteActivityModal] = useState<boolean>(false);
  const { displaySnackbarMessage, displayApiResult } = useSnackbarContext();
  const { refetchActivities } = useActivitiesContext();
  const [completeActivity] = useMutation(COMPLETE_ACTIVITY);
  const { ability, userTenantId } = useAuthContext();

  // Return null if user does not have 'Complete' permissions
  if (!hasPermissions(ability, 'complete', 'Activity', { tenantId: userTenantId })) {
    return null;
  }

  const handleCompleteActivity = async (activity: ActivityInterface) => {
    const result = await completeActivity({
      variables: {
        input: {
          id: activity.id,
          completedDate: new Date().toISOString().slice(0, 10),
        },
      },
    }).then(
      (result) => {
        displayApiResult(result.data.completeActivity, 'Activity Completed');
        refetchActivities();
      },
      (rejection) => {
        displaySnackbarMessage(rejection.message, 'error');
      }
    );

    setShowCompleteActivityModal(false);
    return result;
  };

  return (
    <>
      {activity && (
        <>
          <Button
            variant='contained'
            color='secondary'
            onClick={() => setShowCompleteActivityModal(true)}
          >
            Complete Activity
          </Button>
          <Dialog
            open={showCompleteActivityModal}
            onClose={() => setShowCompleteActivityModal(false)}
          >
            <Grid container textAlign='center' p={2}>
              <Grid item xs={12}>
                <Typography variant='h5'>{activity.subject}</Typography>
                <TextWrapper>Are you sure you want to complete this activity?</TextWrapper>
              </Grid>
              <Grid item xs={12}>
                <Button onClick={() => handleCompleteActivity(activity)}>Complete</Button>
                <Button onClick={() => setShowCompleteActivityModal(false)}>Cancel</Button>
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>
          </Dialog>
        </>
      )}
    </>
  );
};

export default CompleteActivity;
